import { render } from "./App.vue?vue&type=template&id=0de5fc47&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "@ionic/core/css/core.css?vue&type=style&index=0&lang=css"
import "@ionic/core/css/ionic.bundle.css?vue&type=style&index=1&lang=css"
import "./assets/css/dne-app.css?vue&type=style&index=2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__